import { SerializedStyles, css } from "@emotion/react";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const breakdownTableStyles = (expanded: boolean): SerializedStyles => css`
  display: grid;

  grid-template-rows: 0fr;
  transition: grid-template-rows 0.3s ease-in-out;
  overflow: hidden;
  max-width: 100%;

  &.open {
    grid-template-rows: 1fr;
  }

  & .ReactTable {
    transition: visibility 0.3s ease-in-out;
    visibility: hidden;
    min-width: 0;
  }

  &.open .ReactTable {
    visibility: visible;
  }

  & > div {
    min-height: 0;
    max-width: 1200px;

    .rt-table {
      display: block;
      max-height: ${expanded ? "1400px" : "370px"};
      border: 0;
      overflow: auto;
    }

    .rt-thead {
      border: 0;
      background-color: ${withVar(DesignToken.SurfaceSecondaryDefault)};
      box-shadow: none !important;

      .rt-th {
        background-color: ${withVar(DesignToken.SurfaceSecondaryDefault)};
        border-top: solid 1px ${withVar(DesignToken.BorderBasicPrimary)};
        border-bottom: solid 1px ${withVar(DesignToken.BorderBasicPrimary)};
        box-shadow: none !important;
        padding: 8px 15px;
        border-right: 0;
        font-size: 14px;
        font-weight: 400;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.33;
        letter-spacing: normal;
        color: ${withVar(DesignToken.ContentBasicPrimary)};

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        &.odd {
          background-color: ${withVar(DesignToken.SurfaceTertiaryDefault)};
        }

        &.data-column {
          padding: 8px 20px;
          text-align: center;
        }

        &.vs {
          padding: 8px 0;
          color: ${withVar(DesignToken.ContentBasicDisabled)};
        }

        & > div {
          display: inline-block;

          small {
            display: block;
            font-size: 11px;
            opacity: 0.8;
          }
        }
      }

      &.rthfc-th-fixed-left-last {
        text-align: left;
        overflow: visible;

        &::after {
          content: "";
          position: absolute;
          top: 0;
          right: -5px;
          height: 100%;
          width: 5px;
          z-index: -1;
          border-left: 1px solid ${withVar(DesignToken.BorderBasicPrimary)};
        }
      }

      &.rthfc-th-fixed-right {
        border-left: 0;
        font-weight: 800;
        overflow: visible;

        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: -5px;
          height: 100%;
          width: 5px;
          border-right: 1px solid ${withVar(DesignToken.BorderBasicPrimary)};
          z-index: -1;
        }
      }
    }
  }

  .rt-tbody {
    .rt-tr-group {
      border-bottom: solid 1px ${withVar(DesignToken.BorderBasicSecondary)};
    }

    .rt-tr {
      .rt-td {
        background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
        border: 0;
        padding: 15px;

        font-size: 14px;
        font-weight: 400;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.33;
        letter-spacing: normal;
        color: ${withVar(DesignToken.ContentBasicPrimary)};

        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: center;

        &.odd {
          background-color: ${withVar(DesignToken.SurfaceSecondaryDefault)};
        }

        &.data-column {
          padding: 8px 20px;
          text-align: center;
        }

        &.vs {
          padding: 8px 0;
          color: ${withVar(DesignToken.ContentBasicDisabled)};
        }

        & > div {
          display: inline-block;

          small {
            display: block;
            font-size: 11px;
            opacity: 0.8;
          }
        }

        &.rthfc-th-fixed-left-last {
          text-align: left;
          overflow: visible;

          &::after {
            content: "";
            position: absolute;
            top: 0;
            right: -5px;
            height: 100%;
            width: 5px;
            z-index: -1;
            border-left: 1px solid ${withVar(DesignToken.BorderBasicPrimary)};
          }
        }

        &.rthfc-th-fixed-right {
          border-left: 0;
          font-weight: 800;
          overflow: visible;

          &::after {
            content: "";
            position: absolute;
            top: 0;
            left: -5px;
            height: 100%;
            width: 5px;
            border-right: 1px solid ${withVar(DesignToken.BorderBasicPrimary)};
            z-index: -1;
          }
        }
      }
    }

    .rt-tbody {
      .rt-tr-group {
        border-bottom: solid 1px ${withVar(DesignToken.BorderBasicSecondary)};
      }

      .rt-tr {
        .rt-td {
          background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
          border: 0;
          padding: 15px;

          font-size: 15px;
          font-weight: 400;
          font-style: normal;
          font-stretch: normal;
          line-height: 1;
          letter-spacing: normal;
          color: ${withVar(DesignToken.ContentBasicPrimary)};

          display: flex;
          flex-direction: column;
          align-items: stretch;
          justify-content: center;

          &.odd {
            background-color: ${withVar(DesignToken.SurfaceSecondaryDefault)};
          }

          &.data-column {
            padding: 8px 20px;
            text-align: right;

            > span {
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
            }
          }

          &.vs {
            padding: 8px 0;
          }

          &.rthfc-td-fixed-right {
            border-left: 0;
            font-weight: 800;
            overflow: visible;

            &::after {
              content: "";
              position: absolute;
              top: 0;
              left: -5px;
              height: 100%;
              width: 5px;
              z-index: -1;
              border-right: 1px solid ${withVar(DesignToken.BorderBasicPrimary)};
            }
          }

          &.rthfc-td-fixed-left-last {
            overflow: visible;

            &::after {
              content: "";
              position: absolute;
              top: 0;
              right: -5px;
              height: 100%;
              width: 5px;
              z-index: -1;
              border-left: 1px solid ${withVar(DesignToken.BorderBasicPrimary)};
            }
          }
        }
      }
    }
  }
`;
